import request from '@/utils/request'
import store from '../store'
export function getReportList(search) { // 写报告左侧列表
  search.DepartId = store.getters.departId
  return request({
    url: 'Report/GetReportList',
    method: 'post',
    data: search
  })
}
export function GetTableHeaderConfigs(datas) { // 获取表头信息
  return request({
    url: 'Common/GetTableHeaderConfigs',
    method: 'get',
    params: {
      type: datas.type,
      departId: datas.departId
    }
  })
}
export function ReportByProcedureId(ProcedureId) { // 根据检查编号获取写报告信息
  return request({
    url: 'Report/GetReportByProcedureId',
    method: 'get',
    params: {
      ProcedureId
    }
  })
}

export function GetLock(datas) { // 获取锁
  return request({
    url: 'Report/GetLock',
    method: 'get',
    params: datas
  })
}

export function BodyList(deviceTypeID) { // 检查部位列表
  return request({
    url: '/checkingBodyList',
    method: 'get',
    params: {
      deviceTypeID
    }
  })
}

export function doctorList(hospitalID) { // 诊断医生
  return request({
    url: '/doctorList',
    method: 'get',
    params: {
      hospitalID
    }
  })
}

export function saveReports(params) { // 保存报告
  // 前后端的阴阳性字段阴性值转化
  if (params.isPositive === 0) {
    params.isPositive = 2
  }
  return request({
    url: '/Report/CreateOrUpdateReport',
    method: 'post',
    data: params
  })
}
export function NewReport(params) { // 创建报告
  // 前后端的阴阳性字段阴性值转化
  if (params.isPositive === 0) {
    params.isPositive = 2
  }
  return request({
    url: '/Report/NewReport',
    method: 'post',
    data: params
  })
}
export function StatusRejectedToDiagnosing(params) { // 已驳回状态变更为诊断中
  // 前后端的阴阳性字段阴性值转化
  if (params.isPositive === 0) {
    params.isPositive = 2
  }
  return request({
    url: '/Report/StatusRejectedToDiagnosing',
    method: 'post',
    data: params
  })
}
export function BeginApproveReport(params) { // 创健审核
  // 前后端的阴阳性字段阴性值转化
  if (params.isPositive === 0) {
    params.isPositive = 2
  }
  return request({
    url: '/Report/BeginApproveReport',
    method: 'post',
    data: params
  })
}
export function SubmitReport(params) { // 提交诊断
  // 前后端的阴阳性字段阴性值转化
  if (params.isPositive === 0) {
    params.isPositive = 2
  }
  return request({
    url: '/Report/SubmitReport',
    method: 'post',
    data: params
  })
}
export function DeleteReport(params) { // 放弃诊断
  // 前后端的阴阳性字段阴性值转化
  if (params.isPositive === 0) {
    params.isPositive = 2
  }
  return request({
    url: '/Report/DeleteReport',
    method: 'post',
    data: params
  })
}
export function AbandonApproveReport(params) { // 放弃审核
  // 前后端的阴阳性字段阴性值转化
  if (params.isPositive === 0) {
    params.isPositive = 2
  }
  return request({
    url: '/Report/AbandonApproveReport',
    method: 'post',
    data: params
  })
}
export function RejectReport(params) { // 驳回报告
  // 前后端的阴阳性字段阴性值转化
  if (params.isPositive === 0) {
    params.isPositive = 2
  }
  return request({
    url: '/Report/RejectReport',
    method: 'post',
    data: params
  })
}
export function SubmitApproveReport(params) { // 审核/提交诊断并审核
  // 前后端的阴阳性字段阴性值转化
  if (params.isPositive === 0) {
    params.isPositive = 2
  }
  return request({
    url: '/Report/SubmitApproveReport',
    method: 'post',
    data: params
  })
}
export function RecallReport(params) { // 审核召回报告
  // 前后端的阴阳性字段阴性值转化
  if (params.isPositive === 0) {
    params.isPositive = 2
  }
  return request({
    url: '/Report/RecallReport',
    method: 'post',
    data: params
  })
}
export function AutoSaveReport(params) { // 自动保存
  // 前后端的阴阳性字段阴性值转化
  if (params.isPositive === 0) {
    params.isPositive = 2
  }
  return request({
    url: '/Report/AutoSaveReport',
    method: 'post',
    data: params
  })
}
export function saveModule(params) { // 保存个人模板
  return request({
    url: '/ReportTemplate/CreateOrUpdateReportTemplate',
    method: 'post',
    data: params
  })
}

export function hospitalTemplate(datas) { // 机构模板
  return request({
    url: '/ReportTemplate/GetTemplateDircList',
    method: 'get',
    params: datas
  })
}

export function templateInfo(dircId) { // 模板详情
  return request({
    url: '/ReportTemplate/GetReportTemplate',
    method: 'get',
    params: {
      dircId
    }
  })
}

export function deleteUserReportTemplate(params) { // 删除个人模板
  return request({
    url: '/ReportTemplate/DeleteUserReportTemplate',
    method: 'post',
    data: params
  })
}

export function stateRecord(reportId) { // 状态记录
  return request({
    url: '/Report/GetReportHistoryList',
    method: 'get',
    params: {
      reportId
    }
  })
}

export function historyReport(reportId) { // 历史报告
  return request({
    url: '/Report/GetHistoryReportList',
    method: 'get',
    params: {
      reportId
    }
  })
}

export function PdfPrintTemplateList() { // 打印列表
  var id = store.getters.departId
  return request({
    url: '/Common/GetPdfPrintTemplateList',
    method: 'get',
    params: { departId: id }
  })
}

export function getLatestDispatchedProcedure() {
  var id = store.getters.departId
  return request({
    url: '/Report/GetLatestDispatchedProcedure',
    method: 'get',
    params: { departId: id }
  })
}

export function getLatestFinishedReport() {
  var id = store.getters.departId
  return request({
    url: '/Report/GetLatestFinishedReport',
    method: 'get',
    params: { departId: id }
  })
}

export function GetDiagnosticDeparts() { // 获取当前科室的可分配科室
  var id = store.getters.departId
  return request({
    url: '/Diagnostic/GetDiagnosticDeparts',
    method: 'get',
    params: { departId: id }
  })
}
export function AddDiagnosticAllocation(params) { // 手动分配
  return request({
    url: '/Diagnostic/AddDiagnosticAllocation',
    method: 'post',
    data: params
  })
}
export function RollBackAllocation(params) { // 退回
  return request({
    url: '/Diagnostic/RollBackAllocation',
    method: 'post',
    data: params
  })
}
export function DeletePerform(params) { // 删除检查
  return request({
    url: '/Examin/DeletePerform',
    method: 'post',
    data: params
  })
}
